import { formatDateTimeInAppTimeZone } from "../../../utils/appDateTime";

export const SCOPE_OPTIONS = ["FOLLOW_UP", "TEST"];
export const DIRECTION_OPTIONS = ["OUTBOUND", "INBOUND"];
export const STATUS_OPTIONS = ["SENT", "FAILED", "RECEIVED"];
export const LANGUAGE_OPTIONS = ["en", "es"];

export const SPEC_LABELS = {
  FOLLOW_UP_ADDRESS_CONFIRMATION: "Address Confirmation",
  FOLLOW_UP_SHIP_BACK_REMINDER: "Ship Back Reminder",
  TEST_EMAIL_SMOKE: "Test Email",
};

export const VARIABLE_LABELS = {
  patientFirstName: "First Name",
  patientLastName: "Last Name",
  patientFullName: "Full Name",
  scheduledDueDate: "Due Date",
  displayFollowUpCode: "Follow-Up Code",
  clinicName: "Clinic Name",
  recipientEmail: "Recipient Email",
  templateScope: "Template Scope",
  studyDisplayName: "Study Name",
};

const TOKEN_PATTERN = /\{\{\s*([a-zA-Z][a-zA-Z0-9_]*)\s*\}\}/g;

export const formatDateTime = (value) => {
  if (!value) return "";
  return formatDateTimeInAppTimeZone(value, String(value));
};

export const formatBoolean = (value) => {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return "";
};

export const formatLanguage = (value) => {
  if (value === "en") return "English";
  if (value === "es") return "Spanish";
  return value || "";
};

export const formatSpecCode = (value) => SPEC_LABELS[value] || value || "";

export const formatVariableLabel = (value) => VARIABLE_LABELS[value] || value || "";

export const formatEmailAddress = (value) => {
  if (!value) return "";
  const text = String(value).trim();
  const bracketMatch = text.match(/<([^>]+)>/);
  if (bracketMatch?.[1]) return bracketMatch[1].trim();
  const emailMatch = text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
  return emailMatch ? emailMatch[0] : text;
};

export const formatStatus = (value) => {
  if (!value) return "";
  return String(value).replaceAll("_", " ");
};

export const normalizePage = (response) => {
  const payload = response?.data || response || {};
  return {
    content: Array.isArray(payload.content) ? payload.content : [],
    page: Number(payload.page || 0),
    size: Number(payload.size || 25),
    totalElements: Number(payload.totalElements || 0),
    totalPages: Number(payload.totalPages || 0),
  };
};

export const normalizeTemplates = (response) => {
  const payload = response?.data || response || {};
  if (Array.isArray(payload.templates)) return payload.templates;
  if (Array.isArray(payload.content)) return payload.content;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const normalizeSpecs = (response) => {
  const payload = response?.data || response || {};
  if (Array.isArray(payload.specs)) return payload.specs;
  if (Array.isArray(payload.content)) return payload.content;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const extractTemplateVariables = (value) => {
  const variables = new Set();
  const text = value || "";
  let match = TOKEN_PATTERN.exec(text);
  while (match) {
    variables.add(match[1]);
    match = TOKEN_PATTERN.exec(text);
  }
  TOKEN_PATTERN.lastIndex = 0;
  return Array.from(variables);
};

export const templateIdentity = (template) => {
  return `${template?.specCode || ""}/${template?.language || ""}`;
};

export const getErrorMessage = (error, fallback) => {
  return error?.response?.data?.message || error?.message || fallback;
};
